import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { useUserStore } from '../store/userStore';
import {SERVER_URL} from "../config";

const Auth = () => {
  const [name, setName] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const setUser = useUserStore((state) => state.setUser);

  const handleAuth = async (e) => {
    e.preventDefault();
    if (!name.trim()) {
      toast.error('Please enter your name');
      return;
    }

    setLoading(true);
    try {
      const res = await fetch(`${SERVER_URL}/api/auth`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ name: name.trim() })
      });

      if (!res.ok) {
        throw new Error('Authentication failed');
      }

      const data = await res.json();

      // Store in Zustand (token+user)
      setUser(data.user.id, data.user.name, data.token);

      toast.success(`Welcome, ${data.user.name}!`);
      navigate('/lobby');
    } catch (error) {
      console.error('Auth failed:', error);
      toast.error('Authentication failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col bg-gray-50">
      {/* Header */}
      <header className="bg-white shadow-md px-4 lg:px-8">
        <div className="max-w-7xl mx-auto flex justify-between items-center">
          <img
            src="/img/logo.png"
            alt="Vulavula Co-Pilot Logo"
            className="h-18 lg:h-24 w-auto object-contain"
          />
        </div>
      </header>

      {/* Main Content */}
      <div className="flex-1 flex items-center justify-center p-4">
        <div className="w-full max-w-md">
          {/* Welcome Section */}
          <div className="text-center mb-8">
            <h1 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-3">
              Welcome to Vulavula Copilot
            </h1>
            <p className="text-lg text-gray-600">
              AI-powered conversations in your language
            </p>
          </div>

          {/* Login Card */}
          <div className="bg-white rounded-2xl shadow-lg p-8 border border-gray-200">
            <h2 className="text-2xl font-bold text-gray-900 mb-6">
              Get Started
            </h2>

            <form onSubmit={handleAuth} className="space-y-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Your Name
                </label>
                <input
                  type="text"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-transparent text-gray-900 placeholder-gray-400"
                  placeholder="Enter your name"
                  maxLength={50}
                  required
                />
              </div>

              <button
                type="submit"
                disabled={loading || !name.trim()}
                className="w-full bg-accent-secondary hover:bg-orange-700 text-white font-semibold py-3 px-4 rounded-lg transition-colors uppercase disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {loading ? 'Connecting...' : 'Continue'}
              </button>
            </form>
          </div>

          {/* Footer Text */}
          <div className="text-center mt-6">
            <p className="text-sm text-gray-500">
              Powered by <span className="font-semibold">Lelapa AI</span>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Auth;